// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"65e0165f","239":"bc47392b","455":"97a97c70"}[chunkId] + ".chunk.js";
};